(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.ja = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'データが見つかりません'
      },
      combobox: {
        placeholder: '選択',
        searchPlaceholder: '検索'
      },
      datepicker: {
        apply: '適用',
        clearSelection: '消去',
        pickADays: '曜日を選択します',
        prevYear: '前年',
        nextYear: '翌年',
        prevMonth: '前月',
        nextMonth: '翌月',
        year: '',
        month1: '1月',
        month2: '2月',
        month3: '3月',
        month4: '4月',
        month5: '5月',
        month6: '6月',
        month7: '7月',
        month8: '8月',
        month9: '9月',
        month10: '10月',
        month11: '11月',
        month12: '12月',
        weeks: {
          sun: '日',
          mon: '月',
          tue: '火',
          wed: '水',
          thu: '木',
          fri: '金',
          sat: '土'
        },
        months: {
          jan: '1月',
          feb: '2月',
          mar: '3月',
          apr: '4月',
          may: '5月',
          jun: '6月',
          jul: '7月',
          aug: '8月',
          sep: '9月',
          oct: '10月',
          nov: '11月',
          dec: '12月'
        },
        pickADay: '日を選択'
      },
      timepicker: {
        meridiemAM: '午前',
        meridiemPM: '午後'
      },
      dropdown: {
        noDataMessage: 'データが見つかりません'
      },
      filepicker: {
        browse: '参照',
        select: 'ファイルを選択します'
      },
      filter: {
        apply: '適用',
        cancel: 'キャンセル',
        filterButton: 'フィルタ',
        reset: 'フィルタをリセットします',
        resetDefault: 'デフォルトにリセット'
      },
      search: {
        noDataMessage: 'データが見つかりません'
      },
      'multi-search': {
        'separator-and': 'AND',
        'search-button': '検索',
        'search-placeholder': '名前で検索'
      },
      select: {
        all: 'すべて',
        clearSelection: '選択内容をクリア',
        noMatch: 'データが見つかりません',
        noData: 'データなし',
        placeholder: '選択',
        item: 'アイテム',
        selected: '選択済み',
        found: '見つかりました'
      },
      upload: {
        browseButton: '参照',
        text: 'アップロードするには、ファイルをドラッグアンドドロップするか、または [参照] をクリックします。',
        tip: '各最大25MBまでの10個のファイルをアップロードできます'
      },
      table: {
        emptyText: 'データなし'
      },
      tree: {
        emptyText: 'データなし'
      }
    }
  };
  _exports.default = _default;
});